<template lang="html">
  <div class="component-wrapper">
    <v-main >
      <ParallaxIceverg />
      <h1 class="text-center">Política de cookies</h1>
      <section class="container flex">
        <h2>Definición de las cookies</h2>
        <p>Las cookies son pequeños archivos de texto que se almacenan localmente en la caché de su navegador de Internet. Cuando vuelve a visitar el mismo sitio, las cookies permiten al sitio web reconocer su navegador y como resultado, almacenar sus preferencias de usuario.</p>
        <h2>Tipos y función de las cookies</h2>
        <p>
          <ol>
            <li><b>Propias: </b>Enviadas desde un equipo o dominio gestionado por el titular de la web.</li>
            <li><b>de Terceros: </b>Enviadas desde un equipo o dominio que no es gestionado por el titular de la web.</li>
            <li><b>de Sesión: </b>Recogen datos durante la navegación del usuario a través de la página web.</li>
            <li><b>Permanentes: </b>Permiten acceder a datos del terminal del usuario por un periodo definido por el responsable de la cookie. </li>
            <li><b>Técnicas: </b>Permiten al usuario la navegación a través de una web y el uso de diferentes opciones o servicios.  </li>
            <li><b>de Personalización: </b>Permiten al usuario acceder al servicio con ciertas características.  </li>
            <li><b>de Análisis: </b>Permiten el seguimiento y análisis de comportamiento del usuario de webs a las que están vinculadas, con la finalidad de introducir mejoras en función de los datos agregados. </li>
            <li><b>Publicitarias: </b>Permiten la gestión de los espacios publicitarios del editor en base a ciertos criterios, como el contenido editado o la frecuencia de accesos.</li>
          </ol>
        </p>
        <h2>Desactivar cookies</h2>
        <p>
          Puede desactivar el uso de cookies propias y de terceros mediante la configuración de las opciones del navegador instalado en su equipo:
          <ol>
            <li><a href="http://windows.microsoft.com/es-es/windows7/how-to-manage-cookies-in-internet-explorer-9" target="_blank">Internet Explorer 9</a></li>
            <li><a href="https://support.google.com/chrome/answer/95647?hl=es" target="_blank">Chrome</a></li>
            <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-web" target="_blank">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/kb/ph5042?locale=es_ES" target="_blank">Safari</a></li>
          </ol>
        </p>
        <p>
          <b>Le informamos de que, en caso de deshabilitar el uso de las cookies, puede incidir en las funcionalidades que ofrece nuestra web</b>. Para más información sobre sus datos personales ver la <a href="/privacy">política de privacidad</a>.
        </p>
        <h2>Identificación de los responsables de las cookies y del tratamiento de los datos obtenidos </h2>
        <p>El responsable de las cookies propias y del tratamiento de los datos obtenidos será <b>ICEVERG</b>. El email de contacto es: info@iceverg.com</p>
        <p>El responsable de las cookies de terceros es Google Analytics. Habilitado: <span class="d-inline"><v-switch class="d-inline-block" v-model="analyticsEnabled" @change="toggle($event)"></v-switch></span></p>
      </section>
    </v-main>
    <Footer />
  </div>
</template>

<script>
import ParallaxIceverg from '@/components/sections/ParallaxIceverg';
import Footer from '@/components/Footer';
  export default {
    name: "CookiePolicy",
    components: {
      ParallaxIceverg,
      Footer
    },
    data: () => ({
      analyticsEnabled: undefined,
    }),
    mounted(){
      const initValue = localStorage.analyticsEnabled;
      if ( initValue !== undefined) {
        this.analyticsEnabled = initValue === 'true';
      } else {
        this.analyticsEnabled = true;
      }
    },
    methods: {
      toggle($event) {
        if ($event) {
          this.$gtag.optIn();
          localStorage.analyticsEnabled = true;
        } else {
          this.$gtag.optOut();
          localStorage.analyticsEnabled = false;
        }
      }
    }
  }
</script>

<style lang="css">
h1{
  padding-top: 50px;
}
p{
  padding-top: 15px
}
h2{
  margin-top:45px;
}
</style>
